export const load = () => ({
	title: '',
	description: '',
	showTitle: false,
});
